import React from "react";
import { useEffect, useState } from "react";
import LiveChatPageHeaderComponent from "./live-chat-popup-page-header.component";
import Emojis from '../conversations/emojis';
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import Config from "../../config";
import { ToasterTexts } from "../shared/constants";
import { LiveChatService } from "../../services/channels/LiveChatService";
import { ChanneTicketingStatus, ChannelDeliveryStatus, ChannelType } from "../../models/channels/channels.model";
import { UtilityService } from "../../services/UtilityService";
import DisplayChannelConversation from "./live-chat-display-conversation";
import { ListenLiveChatMessageParticipants, ListenLiveChatMessages, RemoveLiveChatMessageParticipantsListener, RemoveLiveChatMessagesListener, } from '../../grpc/services/message.service';
import { UpdateChannelConversationHistory } from "../../actions";
import ImageComponent from "../shared/media/image.component";
import Video from "../shared/media/video.component";
import AudioType from "../shared/media/audio.component";
import { MediaFileType, MediaType, MessageType } from "../../models/media.models";
import { LiveChatByFalkonSystemsIcon, LiveChatMediaCancelIcon, LivechatAttachmentIcon, LivechatEmojiIcon, LivechatSendMessageIcon, MediaDefaultIcon, MediaTxtIcon, PdfIcon, WordIcon, XlsIcon, ZipIcon, LivechatEmojiCloseIcon, LiveChatStatusClosedIcon, StarFilledIcon, StarIcon, FaceBookIcon, WhatsAppIcon } from "../../icon";
import { ChannelConversationStatus, ChannelMessageItem, mapToChannelMessage, MessageCategory } from "../../models/conversations";
import * as selector from '../../selectors/selectors';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Mentions from "../shared/mentions";
import { ChannelService } from "../../services/channels/ChannelAcountService";
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import UploadLoader from "../shared/loaders/uploading-loader.json";
import { ChannelConversationService } from "../../services/channels/ChannelConversationService";
import IsTypingAnimation from "../shared/loaders/new-message-typing-animation.json";
import { Button } from "@mui/material";
import livechatPageLoader from "../shared/loaders/live-chat-page-loader.json";


let debounceTimer;
const debounce = (callback, time) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(callback, time);
}
interface IProps {
    ChannelId: string;
    Title: string;
    DeviceId: string;
    UserID: string;
    LatestSession: number;
    handleEndChat: () => void;
    handleChannelStatus: () => void;
    Icon: string;
    IsMobile: boolean;
    ValidatedUrl: string;
    IsLogedUser: boolean
    IsShareToChatLink?: boolean;
    Sounds: boolean;
    IsOrgnizationActive: boolean;
    ConversationStatus: number;
    SetShowRating: () => void;
    ShowRating: boolean;
    FalkonBranding: boolean;
    LivechatTheme: string;
    IncludeQuestionarrie: boolean;
    WidgetType?: number;
    WhatsappUrl?: string;
    FaceBookUrl?: string;
    HeaderTextColor: string;
}

const LiveChatConversationComponent: React.FC<IProps> = (props: IProps) => {
    const dispatch = useDispatch()
    const ChannelHistory: { [key: string]: ChannelMessageItem[] } = useSelector(selector.ChannelHistory)
    const ChannelConversations = useSelector(selector.ChannelConversations)
    const IsMobileDevice = useSelector(selector.isMobileDevice)

    const [mediaIcon, setMediaIcon] = useState<any>();
    const [media, setMedia] = useState("");
    const [mediaUrl, setMediaUrl] = useState("");
    const [mediatype, setMediatype] = useState("");
    const [mediaName, setMediaName] = useState("");
    const [messages, setMessages] = useState<any[]>([])
    const [showEmojis, setShowEmojis] = useState<boolean>(false);
    const [body, setBody] = useState<string>("")
    const [emoji, setEmoji] = useState<string>("")
    const [audioUrl, setAudioUrl] = useState<any>("")
    const [audio, setAudio] = useState(new Audio(audioUrl));
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [soundsOn, SetSoundsOn] = useState<boolean>(props.Sounds);
    const [mediaUploading, setMediaUploading] = useState<boolean>(false);
    const [IsTyping, setIsTyping] = useState<boolean>(false);
    const [innerHeight, setInnerHeight] = useState<any>();
    const [chatAgainCard, setChatAgainCard] = useState<boolean>(false);
    const [ratingvalue, setRatingValue] = useState<number>(0);
    const [showRatingCard, setShowRatingCard] = useState<boolean>(false)
    const [isExpanded, setIsExpanded] = useState(false);
    const [isRatingExpanded, setIsRatingExpanded] = useState(false);
    const [composerFocus, setComposerFocus] = useState(false);
    const [pageLoader, setPageLoader] = useState<boolean>(false);

    useEffect(() => {
        if (!messages && !composerFocus) {
            setComposerFocus(true)
        }
    }, [messages])

    useEffect(() => {
        setTimeout(() => {
            setIsExpanded(true);
        }, 1);
    }, []);

    useEffect(() => {
        if (showRatingCard) {
            setTimeout(() => {
                setIsRatingExpanded(true);
            }, 1);
        }
    }, [showRatingCard]);


    useEffect(() => {
        UtilityService.convertUrlToBlob("https://s3.us-central-1.wasabisys.com/falkonsms-develop/live-chat/Live-chat-notify-sound").then(
            res => setAudioUrl(res)
        )
    }, [])

    useEffect(() => {
        if (ChannelConversations.length) {
            if (ChannelConversations.find(x => x.ID === props.UserID)?.Ticket?.Status === ChanneTicketingStatus.Closed && ChannelConversations.find(x => x.ID === props.UserID)?.Status !== ChannelConversationStatus.INACTIVE && ChannelConversations.find(x => x.ID === props.UserID)?.Status !== ChannelConversationStatus.CONVERSATION_DELETED) {
                setChatAgainCard(true)
                setShowRatingCard(true)
            }
            if (ChannelConversations.filter(x => x.UserName === "Anonymous_User")?.find(x => x.ID === props.UserID)?.Ticket?.Status === ChanneTicketingStatus.Open && ChannelConversations.filter(x => x.UserName === "Anonymous_User")?.find(x => x.ID === props.UserID)?.Status === ChannelConversationStatus.ACTIVE) {
                if (chatAgainCard) {
                    setChatAgainCard(false)
                    setShowRatingCard(false)
                }
            }
            if (ChannelConversations.filter(x => x.UserName === "Anonymous_User")?.find(x => x.ID === props.UserID)?.Status === ChannelConversationStatus.INACTIVE) {
                UpdateChannelConversationHistory(dispatch, props.UserID, [])
                props.handleEndChat();
            }
            if (ChannelConversations.find(x => x.ID === props.UserID)?.Ticket?.Status === ChanneTicketingStatus.Closed && props.ShowRating && props.IncludeQuestionarrie) {
                setShowRatingCard(true)
            }
        }

    }, [ChannelConversations])

    useEffect(() => {
        if (!props.IsLogedUser && props.ConversationStatus === ChanneTicketingStatus.Closed) {
            setChatAgainCard(true)
            // setShowRatingCard(true)
        }
    }, [props.UserID])

    useEffect(() => {
        setAudio(new Audio(audioUrl))
    }, [audioUrl])


    const scrollRef = React.createRef<any>()


    const onClickshowemojis = () => {
        setShowEmojis(!showEmojis)
    };

    const CloseEmojis = () => {
        setShowEmojis(false)
    }

    const toBase64 = (file: any) =>
        new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const closeMedia = () => {
        setMedia("");
        setMediaUrl("");
        setMediatype("");
        setMediaName("");
    };

    const handleEmojiSelect = (e: any) => {
        setEmoji(e.native)
        setTimeout(() => {
            setEmoji("")
        }, 100)
    };

    const onMediaInsert = async (e: any) => {
        let file = e.target.files[0];
        if (file != null && file.size < Config.CHANNEL_FILE_SIZE) {
            e.target.value = "";
            setMedia(file);
            setMediaUrl(await toBase64(file));
            setMediatype(getMediaType(file.type));
            setMediaName(file.name);
        } else {
            e.target.value = "";
            setToast(
                ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", (Config.CHANNEL_FILE_SIZE / 1000000).toFixed(0)),
                ToasterType.DANGER
            );
        }
    };


    const ConnectToConnectGRPC = () => {
        ListenLiveChatMessageParticipants();
        ListenLiveChatMessages();
    }

    const DisconnectToGRPC = () => {
        RemoveLiveChatMessageParticipantsListener();
        RemoveLiveChatMessagesListener();
    }

    useEffect(() => {
        sessionStorage.setItem("grpcId", props.DeviceId);
        ConnectToConnectGRPC();
        convRefresh()
        return () => {
            DisconnectToGRPC()
        }
    }, [props.DeviceId])

    useEffect(() => {
        setTimeout(() => {
            if (!!scrollRef.current) {
                scrollRef.current.scrollTop = scrollRef?.current?.scrollHeight
            }
        }, 10);
    }, [messages?.length, showEmojis, mediaUrl, innerHeight, scrollRef])

    useEffect(() => {
        const handleResize = () => {
            setInnerHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (ChannelHistory[props.UserID]?.length && isFirstRender) {
            setIsFirstRender(false);
        }
        else {
            if (ChannelHistory[props.UserID]?.length && soundsOn) {
                audio.play()
            }
        }
    }, [messages?.filter(x => x.MessageType !== "TICKET").filter(x => x.MessageType !== "UPDATE").length])

    useEffect(() => {
        let msg = ChannelHistory[props.UserID]
        if (!!msg) {
            setMessages([...msg]?.sort((a, b) => new Date(a.CreatedAt)?.getTime() - new Date(b.CreatedAt)?.getTime()))
            setComposerFocus(true)
        }
    }, [ChannelHistory[props.UserID]])

    const convRefresh = () => {
        LiveChatService.getLiveChatHistoryByLatestSession(props.UserID, props.LatestSession).then((res) => {
            UpdateChannelConversationHistory(dispatch, props.UserID, res.data.map(x => mapToChannelMessage(x)))
        }).catch(err => { })
    }

    const clearChat = () => {
        LiveChatService.ClearLiveChatSession(props.UserID, new Date().valueOf()).then((res) => {
            UpdateChannelConversationHistory(dispatch, props.UserID, [])
        }).catch(err => {
        })
    }

    const endChat = () => {
        if (!!messages.filter(x => !x.IsOutbound)?.length && props.IncludeQuestionarrie) {
            setShowRatingCard(true)
        }
        else {
            setPageLoader(true)
            LiveChatService.EndLiveChatSession(props.UserID).then((res) => {
                setIsExpanded(false)
                UpdateChannelConversationHistory(dispatch, props.UserID, [])
                ChannelService.channelAccountOfflineStatus(props.UserID, 4)
                props.handleEndChat();
                setPageLoader(false)
            }).catch(err => {
            })
        }

    }

    const clearMessages = () => {
        setBody("")
        closeMedia();
    };

    const sendMessage = () => {
        if (!!body.trim()) {
            LiveChatService.ReceiveLiveChatMessage({ sender: { id: props.UserID }, recipient: { id: props.ChannelId }, messagebody: { text: body.trim() } }).
                then(() => {
                    setComposerFocus(false)
                }
                ).catch((err) => {
                    if (!!err && err?.response?.data === "Account is not active") {
                        props.handleChannelStatus()
                    }
                })
        }
        if (!!media) {
            setMediaUploading(true);
            var formData = new FormData();
            formData.append("file", media);
            LiveChatService.ReceiveLiveChatMedia(props.UserID, mediatype, formData).
                then((res) => {
                    setComposerFocus(false)
                    setMediaUploading(false);
                    closeMedia();
                })
                .catch(err => {
                    setToast(err.response, ToasterType.DANGER, "default")
                })
        }
        setBody("")
        setShowEmojis(false)
        if (props.IncludeQuestionarrie) {
            props.SetShowRating()
        }
    }

    const getFileName = (): string => {
        var Name = mediaName.split('.')[0]
        return Name.slice(0, 18) + (mediaName.length > 18 ? "..." : ".");
    }

    const getFileExtension = (): string => {
        let parts = mediaName.split('.');
        return parts[parts.length - 1];
    }

    useEffect(() => {
        setMediaIcon(getMediaTypeIcon(mediatype, mediaUrl))
    }, [mediatype, mediaUrl])

    useEffect(() => {
        let filteredMessages = messages?.filter(x => x.IsOutbound)?.filter(x => x.MessageCategory !== MessageCategory.Ticketing_Message).filter(x => x.MessageCategory !== MessageCategory.Livechat_Loggedin_Update_Message)
        let count = filteredMessages.filter(x => x.DeliveryStatus !== ChannelDeliveryStatus.READ)?.length
        let message = !!filteredMessages ? filteredMessages[filteredMessages.length - 1] : ""
        if (!!count) {
            window.parent.postMessage({ action: 'showNotification', message: message.Message, unreadcount: count }, "*")
        }
    }, [messages])


    useEffect(() => {

        const addlis = (event) => {
            const receivedMessage = event.data;
            const status = receivedMessage.status;
            if (status === 'Online') {
                ChannelService.channelAccountOnlineStatus(props.UserID, 4).then(x => {
                }).catch(y => {
                })
            }
            if (status === 'Offline') {
                ChannelService.channelAccountOfflineStatus(props.UserID, 4).then(x => {
                }).catch(y => {
                })
            }
            if (status === 'Delivered') {
                LiveChatService.deliverdMessageStatus({ time: new Date().valueOf(), sender: { id: props.UserID }, recipient: { id: props.ChannelId } }).then(x => {
                }).catch(y => {
                })
            }
            if (status === 'Read') {
                LiveChatService.ReadMessageStatus({ time: new Date().valueOf(), sender: { id: props.UserID }, recipient: { id: props.ChannelId } }).then(x => {
                }).catch(y => {
                })
            };
        }
        window.addEventListener("message", addlis)

        return () => {
            window.removeEventListener("message", addlis)

        };
    }, [])

    const onKeyChange = (event: any) => {
        if (event?.keyCode === 13) {
            sendMessage()
            event.stopPropagation();
            event.preventDefault();
            return
        }
    }

    const getMediaTypeIcon = (
        type: any,
        urlMedia: string,
    ) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                    return (
                        <ImageComponent
                            MediaUrl={urlMedia}
                            classname={"w-3 h-3"}
                            text={true}
                        />
                    );
                case MediaType.VIDEO:
                    return <Video MediaUrl={urlMedia} controls={false} />;
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <AudioType MediaUrl={urlMedia} controls={true} />
                case MediaFileType.PDF:
                    return <PdfIcon />
                case MediaFileType.ZIP:
                    return <ZipIcon />
                case MediaFileType.DOC:
                    return <WordIcon />
                case MediaFileType.DOCX:
                    return <WordIcon />
                case MediaFileType.XLSX:
                    return <XlsIcon />
                case MediaFileType.TXT:
                    return <MediaTxtIcon />
                default:
                    return <MediaDefaultIcon />
            }
        }
    };

    const getMediaType = (type: string) => {
        if (type != null) {
            const mediatype = type.split('/')[0];
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                    return MessageType.IMAGE
                case MediaType.VIDEO:
                    return MessageType.VIDEO
                case MediaType.AUDIO:
                    return MessageType.AUDIO
                default:
                    return MessageType.FILE
            }
        }
    }

    const getMessageDateTimeDayWise = (index: number) => {
        const Msgs = messages.filter(x => x.MessageType !== "TICKET")
        if (!Msgs[index].Message) return "";
        var newDate = UtilityService.convertToDateWithWeekFormat(
            Msgs[index].CreatedAt?.replace(" +0000 UTC", "Z")
        );
        if (index === 0) return newDate;
        var prevDate = UtilityService.convertToDateWithWeekFormat(
            Msgs[index - 1].CreatedAt?.replace(" +0000 UTC", "Z")
        );
        return newDate !== prevDate ? newDate : "";
    }

    const onChange = (event: any) => {
        setBody(event.target.value.replace(/[\u200B-\u200D\uFEFF]/g, ''))
        if (!IsTyping && event.target.value) {
            if (ChannelConversations.find(x => x.ID === props.UserID)?.Ticket?.Status === ChanneTicketingStatus.Open) {
                setIsTyping(true)
                ChannelConversationService.IsTyping(props.UserID, { user_typing: true, business_typing: ChannelConversations?.length ? ChannelConversations?.find(x => x.ID)?.BusinessTyping : false }).then(res => {
                }).catch(() => {
                })
            }
            return
        }
    }

    const HandleSounds = (sounds_) => {
        SetSoundsOn(sounds_)
        LiveChatService.UpdateUserNotificationSounds(props.UserID, sounds_).then((res) => {

        }).catch((err) => {

        })
    }

    const HandleBlur = (event: any) => {
        stopUserTyping()
    }


    const HandleKeyDown = (event: any) => {
        if (event.ctrlKey && event.keyCode === 13) {
            stopUserTyping()
            return
        }
        if (event.keyCode === 27) {
            stopUserTyping()
            return
        }
    }


    useEffect(() => {
        debounce(() => stopUserTyping(), 5000)
    }, [IsTyping])


    const stopUserTyping = () => {
        if (ChannelConversations && IsTyping) {
            setIsTyping(true)
            if (ChannelConversations.find(x => x.ID === props.UserID)?.Ticket?.Status === ChanneTicketingStatus.Open) {
                ChannelConversationService.IsTyping(props.UserID, { user_typing: false, business_typing: ChannelConversations?.length ? ChannelConversations?.find(x => x.ID)?.BusinessTyping : false }).then(res => {
                    setIsTyping(false)
                }).catch(() => {
                })
            }
        }
    }

    const handleChatAgain = () => {
        ChannelConversationService.UpdateChannelTicketingStatusOpen(props.UserID).then((res) => {
            setChatAgainCard(false)
            setShowRatingCard(false)
        }).catch(() => {
        })
    }


    const submitRating = () => {
        setIsRatingExpanded(false)
        setPageLoader(true)
        LiveChatService.EndLiveChatSession(props.UserID).then((res) => {
            UpdateChannelConversationHistory(dispatch, props.UserID, [])
            ChannelService.channelAccountOfflineStatus(props.UserID, 4)
            props.handleEndChat();
            setPageLoader(false)
        }).catch(err => {
        })
        let agentId = !!messages?.filter(x => x.IsOutbound)?.filter(x => x.MessageCategory === MessageCategory.Basic_Message)?.at(-1)?.SenderID ? messages?.filter(x => x.IsOutbound)?.filter(x => x.MessageCategory === MessageCategory.Basic_Message)?.at(-1)?.SenderID : "UN_ASSIGN"
        let data = {
            agent_id: agentId,
            rating: ratingvalue
        }

        LiveChatService.ChatRating(props.UserID, data).then(() => {

        }).catch(() => {

        })
    }

    const handleToOpen = (url?: string) => {
        window.open(url, '_blank')
    }

    return (
        <div className={` ${props.IsShareToChatLink && !props.IsMobile ? `${IsMobileDevice ? "" : "w-v-60"} h-p-100 m-auto box-shadow-live-chat-input  ` : "w-p-100  h-p-100"} d-flex flex-direction bg-color-live-chat-widget-hist-background o-hidden`}>
            <LiveChatPageHeaderComponent IsLoginComponent={false} Title={props.Title} ClearChat={clearChat} EndChat={endChat} Icon={props.Icon} IsMobile={props.IsMobile} ValidatedUrl={props.ValidatedUrl} IsLogedUser={props.IsLogedUser} UserID={props.UserID} LatestSession={props.LatestSession} SetShowEmojis={CloseEmojis} IsShareToChatLink={props.IsShareToChatLink} Status="online" SoundsOn={soundsOn} HandleSoundsOn={HandleSounds} IsOrgnizationActive={props.IsOrgnizationActive} LivechatTheme={props.LivechatTheme} WidgetType={props.WidgetType} HeaderTextColor={props.HeaderTextColor} />
            {pageLoader ?
                <AnimateLoaderComponent LoaderAnimation={livechatPageLoader} />
                :
                <>
                    <div className={`min-h-40 w-p-100 flex-1 o-hidden`} >
                        {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="d-flex align-center color-live-chat-anonymous py-2 brt-5 h-p-5 bg-color-secondary">
                            <div className={`ml-2  ${props.IsMobile ? "r-h4-medium" : "r-h6-medium"}`}>Connect with</div>
                            {!!props.FaceBookUrl && <FaceBookIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} className={`${props.IsMobile ? "mx-2" : "mx-1"} c-pointer`} onClick={() => handleToOpen(props.FaceBookUrl)} />}
                            {!!props.WhatsappUrl && <WhatsAppIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} onClick={() => handleToOpen(props.WhatsappUrl)} className="c-pointer" />}
                        </div>
                        }
                        <div className={`w-p-100  o-y-scroll bg-color-live-chat-widget-hist-background h-p-100`} ref={scrollRef}>
                            {!!messages && messages.filter(x => x.MessageType !== "TICKET").map((x, index) => {
                                return <div>
                                    <div className={`color-conv-hist-date-day t-align-center r-h6-medium mb-2`}>
                                        {getMessageDateTimeDayWise(index)}
                                    </div>
                                    <DisplayChannelConversation
                                        ChannelType={ChannelType.LIVE_CHAT}
                                        MessageData={{ ...x, IsOutbound: !x.IsOutbound }}
                                        OpenForwardMessage={() => { }}
                                        ProfilePicLink={props.Icon}
                                        IsWidget={props.IsShareToChatLink && !props.IsMobile ? false : true}
                                        IsMobile={props.IsMobile}
                                        UserName={props.Title}
                                        BackgroundColor={props.LivechatTheme}
                                        Icon={props.Icon}
                                        WidgetType={props.WidgetType}
                                        IsExpanded={isExpanded}
                                    />
                                </div>
                            })}
                            {ChannelConversations && ChannelConversations?.find(x => x.ID)?.BusinessTyping &&
                                <div className={`d-flex w-8 mt-2 ml-2 mb-1`}>
                                    <div className='d-flex align-end'>
                                        <img className={` w-3 h-3 br-5 mr-1 mb-1`} src={props.Icon} />
                                        <div className='live-chat-inboundmsg bg-color-secondary d-flex justify-center align-center w-8 h-5'>
                                            <AnimateLoaderComponent LoaderAnimation={IsTypingAnimation} className={"d-flex justify-center align-center"} />
                                        </div>
                                    </div>
                                </div>
                            }
                            {showRatingCard &&
                                <div className={`w-p-100 d-flex justify-center align-center py-2 animate1 ${isRatingExpanded ? "expanded" : ""}`}>
                                    <div className="w-p-90 mx-auto my-4 h-24 d-flex flex-direction box-shadow-channel bg-color-secondary py-3 br-2">
                                        <LiveChatStatusClosedIcon className="mx-auto" />
                                        {chatAgainCard &&
                                            <div className="d-flex r-h3-medium justify-center align-center px-1">Business has end the chat ,</div>}
                                        <div className="d-flex r-h3-medium justify-center align-center px-1 pb-1">
                                            How would you rate our service?
                                        </div>
                                        <div className="d-flex align-center justify-center">
                                            {[...Array(5)].map((star, index) => {
                                                return (
                                                    <span
                                                        key={index}
                                                        className="c-pointer py-1 mr-1"
                                                        onClick={() => setRatingValue(index + 1)}
                                                    >
                                                        {index + 1 <= ratingvalue ?
                                                            <StarFilledIcon />
                                                            :
                                                            <StarIcon />}
                                                    </span>
                                                );
                                            })}
                                        </div>

                                        <div className="d-flex justify-between w-p-90 mx-auto">
                                            {chatAgainCard ?
                                                <Button className="w-p-50 h-4 bg-color-live-chat-header color-secondary mx-auto p-1 mr-2" onClick={handleChatAgain}>Chat Again</Button> :
                                                <div></div>
                                            }
                                            <Button className="w-p-50 h-4 color-secondary bg-color-primary-accent mx-auto p-1" onClick={submitRating}>Submit</Button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                    {!showRatingCard &&
                        <div className={`bg-color-secondary ${props.IsMobile ? "min-h-7" : "min-h-8"} ${(showEmojis || !!mediaUrl) ? "" : "pt-2"} pb-1 ${!showEmojis && !mediaUrl && "animate"} ${isExpanded ? "expanded" : ""}`}>
                            {showEmojis && <div className={`d-flex o-hidden ${props.IsShareToChatLink ? "h-20 br-2 live-chat-emojis" : `justify-center align-center live-chat-emojis ${showEmojis && "h-16"} ${(showEmojis && !mediaUrl) && "mb-1"} w-p-100`}`}>
                                <div style={{ zIndex: 100 }} className="d-flex justify-center h-p-100  w-p-100 mx-auto mt-auto">
                                    <Emojis handleEmojiSelect={handleEmojiSelect} isLiveChat={true} />
                                </div>
                            </div>
                            }
                            <div className={` d-flex mx-auto live-chat-media ${!!mediaUrl && (props.IsMobile ? "w-p-72 h-4 pt-1" : "w-p-70  h-4 pt-1")} `}>
                                <div className="h-p-90 w-p-100 d-flex bg-color-live-chat-media-background br-4 mx-auto">
                                    <div className="w-p-15  d-flex align-center">
                                        <div className="o-hidden br-p-50 ml-1" style={{ width: "22px", height: "22px" }}>
                                            {mediaIcon}
                                        </div>
                                    </div>
                                    <div className={`w-p-70 d-flex align-center r-h5-medium color-live-chat-anonymous px-1 w-space`}>
                                        {getFileName() + getFileExtension()}
                                    </div>
                                    <div className="w-p-13 d-flex justify-center align-center ">
                                        {!mediaUploading &&
                                            <LiveChatMediaCancelIcon
                                                className={"c-pointer "}
                                                onClick={closeMedia}
                                            />
                                        }
                                        {mediaUploading && <AnimateLoaderComponent LoaderAnimation={UploadLoader} className={"w-2 h-2"} />}
                                    </div>
                                </div>
                            </div>
                            <div className={`${props.IsMobile ? "max-h-15" : "max-h-15"} w-p-100 d-flex align-end ${(props.IsMobile) ? "justify-around" : "justify-center"}  live-chat-composer`}>
                                <input
                                    color="primary"
                                    accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.xlsx,.zip,"
                                    type="file"
                                    onChange={mediaUploading ? () => { } : onMediaInsert}
                                    id={"icon-button-file"}
                                    style={{ display: 'none' }}
                                />
                                <label htmlFor={"icon-button-file"} className="d-flex align-end h-p-100">
                                    <div className={`b-live-chat-message-composer attachment  ${props.IsMobile ? "w-4 h-4" : "w-5 h-5"} d-flex justify-center align-center br-p-50 mt-auto`}>
                                        <div className="d-flex justify-center align-center attachment">
                                            <div className="d-flex justify-center align-center">
                                                <LivechatAttachmentIcon className={`w-2 h-2 c-pointer`} />
                                            </div>
                                        </div>
                                    </div>
                                </label>
                                <div className={`${props.IsMobile ? "w-p-66" : props.IsShareToChatLink ? "w-p-80" : "w-p-66"} max-h-10 o-hidden ${props.IsMobile ? "br-8" : "br-5"} b-live-chat-message-composer d-flex ${props.IsMobile ? "pl-2 pr-1" : "pl-2"} `} style={{ marginRight: "6px", marginLeft: "6px" }}>
                                    <div className="w-p-100 max-h-10 o-y-scroll bg-color-secondary ">
                                        <div className={`w-p-100 h-p-100 ${props.IsMobile ? "min-h-4" : "min-h-5"} my-auto d-flex align-center`} onKeyDown={onKeyChange}>
                                            <div className={`w-p-100 h-p-100 r-h4-regular `}>
                                                <Mentions
                                                    body={body}
                                                    placeholder={"Write a message..."}
                                                    emoji={emoji}
                                                    onKeyDown={HandleKeyDown}
                                                    onChange={onChange}
                                                    maxLength={960}
                                                    tags={[]}
                                                    id={""}
                                                    openTags={false}
                                                    tagTarget={undefined}
                                                    closeTags={() => { }}
                                                    onBlur={HandleBlur}
                                                    Media={media}
                                                    Focus={composerFocus}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {!props.IsMobile && <div className="d-flex align-center justify-center w-p-15 h-5 mt-auto">
                                        {showEmojis ?
                                            <LivechatEmojiCloseIcon className={`c-pointer w-2 h-2`} onClick={onClickshowemojis} />
                                            :
                                            <LivechatEmojiIcon className="c-pointer w-2 h-2" onClick={onClickshowemojis} />
                                        }
                                    </div>
                                    }
                                </div>
                                <div className={`b-live-chat-message-composer ${props.IsMobile ? "w-4 h-4" : "w-5 h-5"} d-flex justify-center align-center br-p-50 mt-auto`} onClick={(!!body.trim() || (!!media && !mediaUploading)) ? sendMessage : () => { }} style={{ background: (!!body.trim() || (!!media && !mediaUploading)) ? props.LivechatTheme : "#AEAEAE" }}>
                                    <LivechatSendMessageIcon className={`c-pointer w-2 h-2 `} />
                                </div>
                            </div>
                            <div className={`${props.IsMobile ? "h-2" : "h-2"} d-flex justify-center align-center w-p-95 mx-auto pt-1 `} >
                                {props.FalkonBranding && <LiveChatByFalkonSystemsIcon className={`${props.IsMobile ? "h-2 w-2" : "h-2 w-2"}`} />}
                                {props.FalkonBranding && <div className={`d-flex align-center justify-center h-p-100 live-chat-footer color-live-chat-anonymous`}>&nbsp;Powered by&nbsp;&nbsp;<a href="https://www.falkonsystems.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon Systems</a>
                                    &nbsp;&&nbsp;<a href="https://www.falkonsms.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon SMS</a></div>
                                }
                            </div>
                        </div>
                    }
                    {!!showRatingCard && props.FalkonBranding &&
                        <div className={`${props.IsMobile ? "h-4" : "h-4"} d-flex justify-center align-center w-p-100 mx-auto bg-color-secondary animate1 ${isRatingExpanded ? "expanded" : ""}`} >
                            <LiveChatByFalkonSystemsIcon className={`${props.IsMobile ? "h-2 w-2" : "h-2 w-2"}`} />
                            <div className={`d-flex align-center justify-center h-p-100 live-chat-footer color-live-chat-anonymous`}>&nbsp;Powered by&nbsp;&nbsp;<a href="https://www.falkonsystems.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon Systems</a>
                                &nbsp;&&nbsp;<a href="https://www.falkonsms.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon SMS</a>
                            </div>
                        </div>
                    }
                </>}
        </div >
    )
}


export default LiveChatConversationComponent;